(function () {

  function initWeather(block) {

    if (block.dataset.bound) return;
    block.dataset.bound = 'true';

    const lat = block.dataset.lat;
    const lon = block.dataset.lon;
    const unit = block.dataset.unit;
    const API_KEY = block.dataset.apiKey;

    const tempEl = block.querySelector('.temp');
    const descEl = block.querySelector('.desc');
    const timeEl = block.querySelector('.time');
    const greetingEl = block.querySelector('.greeting');
    const locationEl = block.querySelector('.location p');

    fetch(
      `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=${unit}&appid=${API_KEY}`
    )
      .then((r) => r.json())
      .then((data) => {

        if (!data || !data.main) return;

        tempEl.innerText =
          Math.round(data.main.temp) +
          (unit === 'imperial' ? '°F' : '°C');

        descEl.innerText =
          data.weather?.[0]?.description || '';

      });

    function updateTimeAndGreeting() {

      const now = new Date();

      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });

      const hour = now.getHours();

      let greeting = 'Good Evening';

      if (hour >= 5 && hour < 12) greeting = 'Good Morning';
      else if (hour >= 12 && hour < 17) greeting = 'Good Afternoon';
      else if (hour >= 17 && hour < 22) greeting = 'Good Evening';
      else greeting = 'Good Night';

      timeEl.innerText = formatter.format(now) + ' EST';

      if (greetingEl) {
        greetingEl.innerText = greeting + ",";
      }

    }

    /* split location text safely */
    if (locationEl && !locationEl.dataset.split) {

      const text = locationEl.textContent.trim();

      if (text) {

        locationEl.dataset.split = 'true';

        const fragment = document.createDocumentFragment();

        [...text].forEach((char) => {

          const span = document.createElement('span');

          span.textContent =
            char === ' ' ? '\u00A0' : char;

          fragment.appendChild(span);

        });

        locationEl.textContent = '';

        locationEl.appendChild(fragment);

      }

    }

    updateTimeAndGreeting();

    setInterval(updateTimeAndGreeting, 60000);

  }


  /* observe visibility (important for sliders) */
  function observeWeatherBlocks() {

    const observer = new IntersectionObserver(

      (entries) => {

        entries.forEach((entry) => {

          if (!entry.isIntersecting) return;

          initWeather(entry.target);

          observer.unobserve(entry.target);

        });

      },

      { threshold: 0.2 }

    );


    document
      .querySelectorAll('.p7-weather:not([data-bound])')
      .forEach((block) => observer.observe(block));

  }


  document.addEventListener(
    'DOMContentLoaded',
    () => {

      observeWeatherBlocks();

      /* watch gutenverse slider DOM changes */
      const mutationObserver =
        new MutationObserver(() => {

          observeWeatherBlocks();

        });

      mutationObserver.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );

    }

  );

})();